type TooltipProps = {
  content: React.ReactNode;
  children: React.ReactNode;
  isVisible: boolean;
  onClose: () => void;
  classes?: string;
  position?: string;
  withOverlay?: boolean;
};

export const Tooltip = ({
  content,
  children,
  isVisible,
  onClose,
  classes,
  position = 'bottom-full right-[-24px] mt-2 mb-1',
  withOverlay = true
}: TooltipProps) => {
  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={`relative inline-block ${classes}`}>
      {children}
      {isVisible && (
        <>
          {withOverlay && (
            <div className='fixed inset-0 z-50 transition-opacity' onClick={handleOverlayClick} />
          )}
          <div className={`absolute z-50 ${position}`}>
            <div className='filter-pop-up-shadow max-h-32 overflow-y-auto rounded-md bg-white'>
              <div
                className='h-full px-3 py-2 md:py-0.5'
                onClick={(e) => {
                  e.stopPropagation();
                  onClose();
                }}>
                {content}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
